import { Injectable, TemplateRef } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class AppToastService {
    toasts: any[] = [];

    show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
        options.delay = options.delay || 15000;
        const toast = { textOrTpl, ...options };
        this.toasts.push(toast);
        setTimeout(() => {
            this.remove(toast)
        }, toast.delay);
    }

    remove(toast) {
        this.toasts = this.toasts.filter((t) => t !== toast);
    }

    clear() {
        this.toasts.splice(0, this.toasts.length);
    }
}